import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <div className="glass fixed bottom-6 right-6 z-[100] space-y-2 max-w-md w-full">
      {toasts.map(function ({ id, title, description, action }) {
        return (
          <div key={id} className="glass backdrop-blur-xl shadow-2xl border border-slate-200/50 rounded-2xl overflow-hidden animate-in slide-in-from-bottom-4 fade-in duration-300">
            <div className="p-6">
              {title && (
                <div className="mb-2">
                  <p className="text-lg font-semibold text-slate-900">{title}</p>
                </div>
              )}
              {description && (
                <div>
                  <p className="text-base text-slate-700">{description}</p>
                </div>
              )}
              {action && (
                <button onClick={action.onClick} className="mt-2 text-sm font-medium text-velohost-primary hover:underline">
                  {action.label}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}